import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
  name: 'elementSize'
})
export class ElementSizePipe implements PipeTransform {

  transform(element?: HTMLElement): any {
    if (!element) return {};
    const cs: CSSStyleDeclaration = getComputedStyle(element);

    const paddingX: number = parseFloat(cs.paddingLeft) + parseFloat(cs.paddingRight);
    const paddingY: number = parseFloat(cs.paddingTop) + parseFloat(cs.paddingBottom);

    const borderX: number = parseFloat(cs.borderLeftWidth) + parseFloat(cs.borderRightWidth);
    const borderY: number = parseFloat(cs.borderTopWidth) + parseFloat(cs.borderBottomWidth);

    const elementWidth: number = element.offsetWidth - paddingX - borderX;
    const elementHeight: number = element.offsetHeight - paddingY - borderY;

    return { width: elementWidth + 'px', height: elementHeight + 'px'};
  }

}
